import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const islogged = () => {
  const EXPIRATION_HOURS = 8;
  const date = new Date();
  date.setHours(date.getHours() - EXPIRATION_HOURS);
  const token = sessionStorage.getItem("token");
  const expired = +date > +sessionStorage.getItem("tokenTimer");

  if (expired) {
    localStorage.clear();
    sessionStorage.clear();
  }

  return token && !expired;
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      islogged() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/app/helpers/privateRoute.js